import { useMutation } from 'react-query';

import { deleteUser as mutationFn } from 'api/endPoints/deleteUser';

interface DeleteUserParams {
    email: string;
}

export const useMutationDeleteUser = () => {
    return useMutation<unknown, QueryError, DeleteUserParams>('deleteUser', (params: DeleteUserParams) =>
        mutationFn(params),
    );
};
